"section nav article aside header footer main figure figcaption data time mark wbr video audio source track canvas svg math datalist keygen output progress meter details summary command menu".replace(/\w+/g, function(n){
	document.createElement(n)
});

